import { BACKEND_URL } from "../auth/AuthContext";

const FILE_ID_IN_URL = /\/(?:api\/)?files\/([a-f0-9]{32})/i;

/** Extract a 32-char hex file_id from a path, URL, or bare id. */
export function fileIdFromRef(path) {
  if (!path) return null;
  const raw = String(path).trim();
  if (!raw) return null;
  const m = raw.match(FILE_ID_IN_URL);
  if (m) return m[1];
  if (/^[a-f0-9]{32}$/i.test(raw)) return raw;
  return null;
}

/** Build an absolute URL for /api/files/{id} paths (works on zcars.ai same-origin). */
export function resolveMediaUrl(path) {
  if (!path) return "";
  const raw = String(path).trim();
  if (!raw) return "";
  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    const m = raw.match(FILE_ID_IN_URL);
    if (m) return `${BACKEND_URL}/api/files/${m[1]}`;
    return raw;
  }
  if (raw.startsWith("/")) return `${BACKEND_URL}${raw}`;
  if (/^[a-f0-9]{32}$/i.test(raw)) return `${BACKEND_URL}/api/files/${raw}`;
  return `${BACKEND_URL}/api/files/${raw}`;
}

/** Neutral sedan placeholder when listing photos are missing or orphaned in storage. */
export const DEFAULT_LISTING_PLACEHOLDER =
  "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=1200&q=80";

/** First listing image with optional fallback (Unsplash placeholder, etc.). */
export function listingCoverImage(images, fallback = "") {
  const raw = images?.[0];
  if (!raw) return fallback;
  return resolveMediaUrl(raw) || fallback;
}

export function photoEntryFromApi(data, angle) {
  if (!data?.file_id) return null;
  const rel = data.url || `/api/files/${data.file_id}`;
  return {
    angle: data.angle || angle,
    file_id: data.file_id,
    url: resolveMediaUrl(rel),
  };
}
